import { createApi } from '@reduxjs/toolkit/query/react';
import { restBaseQuery } from '../../api/rest/baseQuery';
import { appConfiguration } from '../../configuration/appConfiguration';

type AssetsResponse = {
  items: { id: string }[];
};

type GetAssetsParams = {
  status: string;
  type: string;
};

const assetsSlice = createApi({
  reducerPath: 'assetsApi',
  baseQuery: restBaseQuery(appConfiguration.rioAssets.api.url),
  endpoints: (build) => ({
    getAssets: build.query<AssetsResponse, GetAssetsParams>({
      query: (params) => ({ url: '/assets', params }),
    }),
  }),
});

export const {
  reducer: assetsReducer,
  reducerPath: assetsReducerPath,
  middleware: assetsMiddleware,
  useGetAssetsQuery,
} = assetsSlice;
